import { useMemo, useState } from 'react'
import { useApiListGroup, useApiListNodeGroup } from '../../api-new/state/content'
import { ModalDialog } from '../component/modal-dialog'
import { TextFilter } from './text-filter'
import { ButtonPrimary } from '../component/button'

export const PermissionNodeGroupModal = ({ target, nodeID, allowAdd, allowDelete, onClose, onClosed }) => {
  const [filter, updateFilter] = useState('')

  const apiListGroup = useApiListGroup()
  const apiListNodeGroup = useApiListNodeGroup()

  const filteredItems = useMemo(
    () => {
      let lowerFilter = filter.toLowerCase()
      return apiListGroup.items.filter(i => i.name.toLowerCase().includes(lowerFilter))
    },
    [apiListGroup.items, filter]
  )

  const handleOpen = () => {
    updateFilter('')
    apiListGroup.get()
    apiListNodeGroup.get(`${nodeID}/node`)
  }
  const handleClose = () => onClose && onClose()

  const handleAdd = async groupID => {
    await apiListNodeGroup.post({ nodeID: nodeID, groupID: groupID })
    await apiListNodeGroup.get(`${nodeID}/node`)
  }

  const handleRemove = async groupID => {
    await apiListNodeGroup.delete(`${nodeID}/${groupID}`)
    await apiListNodeGroup.get(`${nodeID}/node`)
  }

  return (
    <ModalDialog target={target} header="Add Group" fullScreen onOpen={handleOpen} onClose={onClosed}>
      <div className="d-flex flex-column h-100">
        <div>
          <TextFilter value={filter} onChange={updateFilter} />
        </div>
        <div className="flex-fill overflow-auto p-2">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 50 }} />
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((group, i) =>
                  <Item
                    key={i}
                    group={group}
                    selectedNodeGroups={apiListNodeGroup.items}
                    allowAdd={allowAdd}
                    allowDelete={allowDelete}
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pt-1 border-top">
          <ButtonPrimary onClick={handleClose}>close</ButtonPrimary>
        </div>
      </div>
    </ModalDialog>
  )
}

const Item = ({ group, selectedNodeGroups, allowAdd, allowDelete, onAdd, onRemove }) => {
  const isChecked = useMemo(() => selectedNodeGroups.findIndex(selectedNodeGroup => selectedNodeGroup.groupID === group.id) !== -1, [group, selectedNodeGroups])

  const handleClick = () => {
    if (isChecked) {
      allowDelete && onRemove && onRemove(group.id)
    } else {
      allowAdd && onAdd && onAdd(group.id)
    }
  }

  return (
    <tr style={{ cursor: 'pointer' }} onClick={handleClick}>
      <td>
        <input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} />
      </td>
      <td>
        {group.name}
      </td>
    </tr>
  )
}
